import { faqState } from './faq.state';
import { faqActions } from './faq.action';
import { faqMutations } from './faq.mutation';

export default {
  namespaced: true,
  state: faqState,
  getters: {},
  actions: faqActions,
  mutations: faqMutations,
};
